import React, { Component } from 'react';
import {
  Badge,
  Button,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  InputGroup,
  InputGroupButton,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  PaginationItem,
  PaginationLink,
  Row,
  Table
} from 'reactstrap';
import Pagination from '../../components/Pagination';

// Firebase
import { app } from '../../base';

const TableRow = (props) => {
  var status = parseInt(props.data.status) && 1;
  return (
    <tr>
      <td><img src={props.data.image || ''} height="64" width="64" /></td>
      <td>{props.data.name || ''}</td>
      <td>{props.data.category_name}</td>
      <td>{props.data.sub_category || ''}</td>
      <td>{props.data.brand_name || ''}</td>
      <td><Badge color={status?'success':'secondary'} onClick={()=> changeStatus(props.rowKey,status)} style={{cursor:'pointer'}}>{status?'Active':'Inactive'}</Badge></td>
      <td align="center">
        <i className="fa fa-pencil fa-lg mr-1 icon-pointer" onClick={()=>props.viewForm(props.rowKey, props.data)}></i>
        <i className="fa fa-remove fa-lg icon-pointer" onClick={()=>props.deleteData(props.rowKey)}></i>
      </td>
    </tr>
  );
}

function changeStatus(key, status){
  app.database().ref('products/' + key).update({
    status: 1-status
  });
}

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Products extends Component {
  constructor() {
    super();
    let data = {
      image: '',
      name: ''
    };

    this.state = {
      brand_id: '',
      brand_options: [],
      category_id: '',
      category_options: [],
      data: data,
      modal: false,
      rows: [],
      pageOfItems: [],
      searchRows: [],
      show: 'none'
    };

    this.onBrandChange = this.onBrandChange.bind(this);
    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.viewForm = this.viewForm.bind(this);
  }

  componentWillMount() {
    app.database().ref('/products').on('value', snapshot=>{
      let items = snapshot.val();
      let rows = [];
      for (let key in items) {
        rows.push(<TableRow key={key} data={items[key]} rowKey={key} viewForm={this.viewForm} deleteData={this.deleteData} />);
      }
      this.setState({
        rows:rows,
        searchRows: rows
      });
    });
  }

  createBrandOptions() {
    app.database().ref('/brands').orderByChild('name').once('value', (snapshot)=>{
      let options = [];
      snapshot.forEach((child)=>{
        options.push(<option key={child.key} value={child.key}>{child.val().name}</option>);
      });
      
      this.setState({
        brand_options: options
      });
    });
  }

  createCategoryOptions() {
    app.database().ref('/categories').orderByChild('name').once('value', (snapshot)=>{
      let options = [];
      snapshot.forEach((child)=>{
        options.push(<option key={child.key} value={child.key}>{child.val().name}</option>);
      });
      this.setState({
        category_options: options
      });
    });
  }

  deleteData(key) {
    if (confirm("Are you sure you want to delete this item?")) {
      app.database().ref('products/' + key).remove()
      .catch((error)=>{
        alert(error.message);
      });
    }
  }

  filterData(searchText, element){
    return (element.props.data.name.toLowerCase().indexOf(searchText) != -1)
  }

  onBrandChange(event) {
    this.setState({
      brand_id: event.target.value
    });
  }

  onCategoryChange(event) {
    this.setState({
      category_id: event.target.value
    });
  }

  onChangePage(pageOfItems) {
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems });
  }

  onSearch(event) {
    event.preventDefault()

    const searchText = this.searchInput.value

    if (this.state.searchRows.length == 0) return;

    var rows = this.state.searchRows.filter(this.filterData.bind(this, searchText));
    this.setState({rows:rows});
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Col md="4">
                  <FormGroup>
                    <form onSubmit={(event) => { this.onSearch(event) }} ref={(form) => { this.searchForm = form }}>
                      <InputGroup>
                        <Input size="10" type="text" placeholder="Enter text here" innerRef={(input) => { this.searchInput = input }}/>
                        <InputGroupButton>
                          <Button color="info">Search</Button>
                        </InputGroupButton>
                      </InputGroup>
                    </form>
                  </FormGroup>
                </Col>
                <Table bordered striped responsive size="sm">
                  <thead>
                  <tr>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Sub Category</th>
                    <th>Brand</th>
                    <th>Status</th>
                    <th className="text-center">Action</th>
                  </tr>
                  </thead>
                  <tbody>{this.state.pageOfItems}</tbody>
                </Table>
                <nav>
                  <Pagination items={this.state.rows} onChangePage={this.onChangePage} />
                </nav>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} className='modal-lg'>
                  <form onSubmit={(event) => { this.updateData(event) }} ref={(form) => { this.editForm = form }}>
                    <ModalHeader toggle={this.toggleModal}>
                      <ShowMessage show={this.state.show} message={this.state.message} />
                    </ModalHeader>
                    <ModalBody>
                      <InputGroup className="mb-3">
                        <Input type="text" placeholder="Product Name" innerRef={(input) => { this.nameInput = input }} defaultValue={this.state.data.name} />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input type="select" name="category" innerRef={(input) => { this.categoryInput = input }} value={this.state.category_id} onChange={this.onCategoryChange}>
                          {this.state.category_options}
                        </Input>
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input type="text" placeholder="Sub Category (optional)" innerRef={(input) => { this.subCatInput = input }} defaultValue={this.state.data.sub_category} />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input type="select" name="brands" innerRef={(input) => { this.brandInput = input }} value={this.state.brand_id} onChange={this.onBrandChange}>
                          {this.state.brand_options}
                        </Input>
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input type="file" name="file" innerRef={(input) => { this.fileInput = input }} />
                      </InputGroup>
                    </ModalBody>
                    <ModalFooter>
                      <Button color="primary">Update</Button>{' '}
                      <Button color="secondary" onClick={this.toggleModal}>Cancel</Button>
                    </ModalFooter>
                  </form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }

  setMessage(msg) {
    this.setState({
      message: msg,
      show: ''
    });
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  updateData(event) {
    event.preventDefault()
    
    const name = this.nameInput.value
    const category = this.categoryInput.value
    const category_name = this.categoryInput.options[this.categoryInput.selectedIndex].text
    const subCategory = this.subCatInput.value
    const brand = this.brandInput.value
    const brand_name = this.brandInput.options[this.brandInput.selectedIndex].text
    const file = this.fileInput.files[0]
    const fileVal = this.fileInput.value
    //console.log(name+"-"+category+'-'+category_name+'-'+brand+'-'+brand_name+'-'+fileVal)

    if (name == '') {
      this.setMessage('All fields must be filled');
      return;
    }

    if (fileVal == '') {
      app.database().ref('products/' + this.state.key).update({
        brand_id: brand,
        brand_name: brand_name,
        category_id: category,
        category_name: category_name,
        name: name,
        sub_category: subCategory
      }).then(()=>{
        this.setState({
          modal: !this.state.modal
        });
      }).catch((error)=>{
        this.setMessage(error.message);
      });
    }
    else {
      this.setMessage('Uploading...');
      
      var re = /(?:\.([^.]+))?$/;
      var ext = re.exec(fileVal)[1];

      var uploadRef = app.storage().ref().child('images/products/'+this.state.key+'.'+ ext);
      var uploadTask = uploadRef.put(file);
      uploadTask.on('state_changed', (storeSnap)=>{
        //console.log('processing')
      }, (error)=>{
        this.setMessage('Upload error');
      }, ()=>{
        app.database().ref('brands/' + this.state.key).update({
          brand_id: brand,
          brand_name: brand_name,
          category_id: category,
          category_name: category_name,
          image: uploadTask.snapshot.downloadURL,
          name: name,
          sub_category: subCategory
        }).then(()=>{
          this.setState({
            modal: !this.state.modal
          });
        }).catch((error)=>{
          uploadRef.delete();
          this.setMessage(error.message);
        });
      });
    }
  }

  viewForm(key, data) {
    this.setState({
      brand_id: data.brand_id,
      category_id: data.category_id,
      data: data,
      key: key,
      message: '',
      modal: !this.state.modal,
      show: 'none'
    });
    this.createCategoryOptions();
    this.createBrandOptions();
  }
}

export default Products;


// WEBPACK FOOTER //
// ./src/views/Products/Products.js